const {Component} = require("react");
const PropTypes = require("prop-types");

class SidebarTrigger extends Component {

	static get propTypes() {
		return {
			label: PropTypes.string.isRequired,
			className: PropTypes.string,
			targetClassName: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			className: "sidebar-trigger",
			targetClassName: "show-sidebar"
		};
	}

	get className() {
		return "btn primary " + this.props.className;
	}

	toggle() {
		let classList = document.body.className.split(" ");
		let index = classList.indexOf(this.props.targetClassName);

		if (index === -1) {
			classList.push(this.props.targetClassName);
		}
		else {
			classList.splice(index, 1);
		}

		document.body.className = classList.join(" ");
	}

	onClick = (e) => {
		e.preventDefault();
		this.toggle();
	};

	render() {
		return (
			<button onClick={this.onClick} className={this.className}>{this.props.label}</button>
		);
	}

}

module.exports = SidebarTrigger;